import React, { useState } from "react";

export function TabsGroup({ tabs, afterTabs }) {
  let [tab, setTab] = useState(0);
  return (
    <div className={"flex flex-col gap-3 flex-grow overflow-auto"}>
      <div className={"flex gap-3"}>
        {tabs.map(
          ({ label, component, icon }, i) =>
            label && (
              <div
                className={
                  "cursor-pointer hover:bg-blue-100 bg-white p-3 rounded flex gap-3 items-center " +
                  (tab == i && "bg-blue-200")
                }
                onClick={() => setTab(i)}
              >
                {icon && <span className={"md:hidden fa fa-" + icon} />}
                <span className={"hidden md:block"}>{label}</span>
              </div>
            )
        )}
        <div className={"flex-grow"}></div>
        {afterTabs}
      </div>

      <div className={"rounded flex-grow overflow-auto"}>
        {tabs[tab].component}
      </div>
    </div>
  );
}
